import { render } from "./form-part-b-declaration.html?vue&type=template&id=528c0338&scoped=true&ts=true&external"
import script from "./form-part-b-declaration.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-declaration.ts?vue&type=script&lang=ts&external"

import "./form-part-b-declaration.scss?vue&type=style&index=0&id=528c0338&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528c0338"]])

export default __exports__